export default "__VITE_ASSET__D6vm95ao__"